import { Base } from '@studiometa/js-toolkit';
import anime from 'animejs';
import Cookies from 'js-cookie';

/**
 * @typedef {Object} LoaderRef
 * @property {HTMLImageElement} background
 */

/**
 * @typedef {Object} LoaderInterface
 * @property {LoaderRef} $refs
 */

/**
 * Homepage class.
 */
export default class Loader extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'Loader',
    refs: ['background'],
  };

  /**
   * Initialize the component's behavior.
   * @this {Loader & LoaderInterface}
   */
  mounted() {
    if (this.$refs.background.complete) {
      this.showBackground();
    } else {
      this.$refs.background.addEventListener('load', this.showBackground);
    }
  }

  /**
   * Show the loader background.
   * @this {Loader & LoaderInterface}
   * @return void
   */
  showBackground() {
    anime({
      targets: this.$refs.background,
      opacity: [0, 1],
      scale: [1.5, 1],
      duration: 1600,
      easing: 'easeOutQuart',
      complete: () => {
        // Trigger animation once ready.
        const ready = document.readyState === 'complete';

        if (ready) {
          this.close();
        } else {
          window.addEventListener('load', () => {
            this.close();
          });
        }
      },
    });
  }

  /**
   * Close the loader.
   * @this {Loader & LoaderInterface}
   * @return void
   */
  close() {
    Cookies.set('show-loader', 'false');

    anime({
      targets: this.$refs.background,
      scale: [1, 1.2],
      easing: 'easeInOutQuart',
      duration: 1600,
      complete: () => {
        this.$el.style.display = 'none';
        document.body.classList.remove('with-loader');
      },
    });

    anime({
      targets: this.$el,
      translateY: '-100%',
      easing: 'easeInOutQuart',
      duration: 1600,
    });
  }

  /**
   * Unbind all events on destroy.
   *
   * @this {Loader & LoaderInterface}
   * @return {Loader} The Loader instance.
   */
  destroyed() {
    return this;
  }
}
